import { render } from "./LinkAccountConfirmation.vue?vue&type=template&id=57d827b2&scoped=true"
import script from "./LinkAccountConfirmation.vue?vue&type=script&lang=js"
export * from "./LinkAccountConfirmation.vue?vue&type=script&lang=js"

import "./LinkAccountConfirmation.vue?vue&type=style&index=0&id=57d827b2&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57d827b2"]])

export default __exports__